export const onlyDigits = (value, limit) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  return limit === undefined ? digits : digits.slice(0, limit);
};

export const brazilianPhoneDigits = value => {
  let digits = onlyDigits(value);
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  return digits.slice(0, 11);
};

export const formatBrazilianPhone = value => {
  const digits = brazilianPhoneDigits(value);
  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  const subscriber = digits.slice(2);
  const split = subscriber.length > 8 ? 5 : 4;
  const number =
    subscriber.length > split
      ? `${subscriber.slice(0, split)}-${subscriber.slice(split)}`
      : subscriber;
  return `(${digits.slice(0, 2)}) ${number}`;
};

export const formatCpf = value => {
  const digits = onlyDigits(value, 11);
  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1-$2');
};

export const formatCnpj = value => {
  const digits = onlyDigits(value, 14);
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\/\d{4})(\d)/, '$1-$2');
};

export const formatCep = value =>
  onlyDigits(value, 8).replace(/^(\d{5})(\d)/, '$1-$2');

export const formatBrazilianDate = value => {
  const rawValue = String(value ?? '').trim();
  const isoDate = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;

  const digits = onlyDigits(rawValue, 8);
  return digits
    .replace(/^(\d{2})(\d)/, '$1/$2')
    .replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
};

export const brazilianDateToIso = value => {
  const rawValue = String(value ?? '').trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) return rawValue;

  const digits = onlyDigits(rawValue, 8);
  if (digits.length !== 8) return '';

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const year = Number(digits.slice(4));
  const date = new Date(Date.UTC(year, month - 1, day));
  const isValid =
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day;

  return isValid
    ? `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    : '';
};

export const formatCurrencyInput = value => {
  if (value === '' || value === null || value === undefined) return '';

  const amount = Number(value);
  if (!Number.isFinite(amount)) return '';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const currencyInputToDecimal = value => {
  const digits = onlyDigits(value);
  return digits ? (Number(digits) / 100).toFixed(2) : '';
};
